import React from 'react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle,
  DialogDescription,
  DialogFooter 
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles, TrendingUp, FileDown, ChevronRight, ShieldCheck } from 'lucide-react';

const WelcomeModal = ({ isOpen, onClose, onStartTour, onLoadDemo, userName }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg max-w-[95vw] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl sm:text-2xl font-serif">
            <span className="flex items-center space-x-2">
              <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-600" />
              <span>Welcome to My<span className="text-emerald-600">Invest</span><span className="text-blue-600">Folio</span>!</span>
            </span>
          </DialogTitle>
          <DialogDescription className="text-sm sm:text-base pt-2">
            {userName ? `Hi ${userName}! ` : 'Hi! '}
            Your private, encrypted place to hold your portfolio together &mdash; and quietly protect it for the people you trust.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 sm:space-y-4 py-3 sm:py-4">
          {/* Quick Feature Overview */}
          <div className="space-y-2 sm:space-y-3">
            <div className="flex items-start space-x-2 sm:space-x-3 p-2 sm:p-3 bg-teal-50 rounded-lg border border-teal-200" data-testid="welcome-pillar-continuity">
              <ShieldCheck className="w-4 h-4 sm:w-5 sm:h-5 text-teal-600 mt-0.5 shrink-0" />
              <div>
                <p className="font-semibold text-xs sm:text-sm text-slate-900">Continuity Records</p>
                <p className="text-[10px] sm:text-xs text-slate-600">A private record of what you own and your trusted contacts</p>
              </div>
            </div>

            <div className="flex items-start space-x-2 sm:space-x-3 p-2 sm:p-3 bg-emerald-50 rounded-lg border border-emerald-200">
              <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 mt-0.5 shrink-0" />
              <div>
                <p className="font-semibold text-xs sm:text-sm text-slate-900">Portfolio Analytics</p>
                <p className="text-[10px] sm:text-xs text-slate-600">Real-time insights and performance tracking</p>
              </div>
            </div>

            <div className="flex items-start space-x-2 sm:space-x-3 p-2 sm:p-3 bg-blue-50 rounded-lg border border-blue-200">
              <FileDown className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 mt-0.5 shrink-0" />
              <div>
                <p className="font-semibold text-xs sm:text-sm text-slate-900">Export Reports</p>
                <p className="text-[10px] sm:text-xs text-slate-600">Download CSV and PDF reports anytime</p>
              </div>
            </div>
          </div>

          {/* Demo Portfolio Option */}
          <div className="border-t pt-3 sm:pt-4">
            <p className="text-xs sm:text-sm text-slate-600 mb-2 sm:mb-3">
              Want to explore first? Try the app with sample investments:
            </p>
            <Button 
              onClick={onLoadDemo}
              variant="outline"
              className="w-full border-emerald-300 hover:bg-emerald-50 text-xs sm:text-sm"
            >
              <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 mr-2" />
              Load Demo Portfolio
            </Button>
          </div>
        </div>

        <DialogFooter className="flex flex-col sm:flex-row gap-2">
          <Button 
            variant="outline" 
            onClick={onClose}
            className="w-full sm:w-auto order-2 sm:order-1 text-xs sm:text-sm"
          >
            Skip Tour
          </Button>
          <Button 
            onClick={onStartTour}
            className="w-full sm:w-auto order-1 sm:order-2 bg-emerald-600 hover:bg-emerald-700 text-xs sm:text-sm"
          >
            Take Quick Tour
            <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4 ml-2" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
